// Prefilled when an advertiser row is switched to Sponsored Ads (US).
export const AMC_MARKETPLACE_ID = 'ATVPDKIKX0DER';

// NA-region marketplaces. The dropdown is creatable, so other regions can still be entered.
export const AMC_MARKETPLACES = [
  { value: 'ATVPDKIKX0DER', label: 'United States · ATVPDKIKX0DER' },
  { value: 'A2EUQ1WTGCTBG2', label: 'Canada · A2EUQ1WTGCTBG2' },
  { value: 'A1AM78C64UM0Y8', label: 'Mexico · A1AM78C64UM0Y8' },
  { value: 'A2Q3Y263D00KWC', label: 'Brazil · A2Q3Y263D00KWC' }
];

export const AdvertiserType = {
  DISPLAY: 'DISPLAY',
  SPONSORED_ADS: 'SPONSORED_ADS'
} as const;
export type AdvertiserTypeType = (typeof AdvertiserType)[keyof typeof AdvertiserType];

export const ADVERTISER_TYPE_LABELS: Record<AdvertiserTypeType, string> = {
  [AdvertiserType.DISPLAY]: 'DSP (DISPLAY)',
  [AdvertiserType.SPONSORED_ADS]: 'Sponsored Ads'
};

// Show the advertiser filter only once the list is long enough to need one.
export const ADVERTISER_FILTER_THRESHOLD = 8;
